// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"4dd50d60","42":"526b12c2","147":"10f578ad","198":"61b7ed34","228":"c3cca297","584":"6fe59cba","835":"f44af9a8","887":"0098b622","922":"aa002497","935":"52fc851a","981":"b2baa691"}[chunkId] + ".chunk.js";
};